import React from "react";
import TYLoadingData from "./TenYearsData.jsx/TYLoadingData";
const TableView = () => {
  return (
    <div className="row">
      <div className="col-md-4">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <TYLoadingData defCode={"LDG_MT"} title={"loading (in MT)"} />
        </div>
      </div>
      <div className="col-md-4">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <TYLoadingData defCode={"LDG_WGN"} title={"Loading wagon"} />
        </div>
      </div>
      <div className="col-md-4">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <TYLoadingData defCode={"DWB"} title={"Divisional wagon balance"} />
        </div>
      </div>
    </div>
  );
};
export default TableView;
